import {IBaseLookup} from "./Ibase.lookup";

export namespace ModifierCode {

    export const lookupName: string = "ModifierCode";

    export interface ModifierCode {
        modifierCodeKey: number;
        code: string;
        description: string;
        active: string;
        lastUpdated: Date;
    }

    export interface ModifierCodeDS extends IBaseLookup {
        modifierCode: ModifierCode[];
    }
}
